import React from 'react';
import { Link } from 'react-router-dom';

function Navigation() {
  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="nav-logo-link">
          <img src="/images/logo.jpeg" alt="Sarayu Urban Logo" className="logo-img" />
          <span className="logo-text">SARAYU URBAN MULTI STATE CO-OPERATIVE CREDIT SOCIETY</span>
        </Link>
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/governance">Governance</Link>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;